import AsyncStorage from '@react-native-async-storage/async-storage';
import type { QueuedReportSubmission } from './offlineReportSubmissionQueue.types';

const REPORT_SUBMISSION_QUEUE_STORAGE_KEY = '@report-submission-queue/v1';

export const readReportSubmissionQueue = async (): Promise<
  QueuedReportSubmission[]
> => {
  try {
    const rawQueue = await AsyncStorage.getItem(
      REPORT_SUBMISSION_QUEUE_STORAGE_KEY,
    );

    if (!rawQueue) {
      return [];
    }

    const parsedQueue = JSON.parse(rawQueue);
    return Array.isArray(parsedQueue)
      ? (parsedQueue as QueuedReportSubmission[])
      : [];
  } catch (error) {
    console.error('Failed to read report submission queue', error);
    return [];
  }
};

export const writeReportSubmissionQueue = async (
  queue: QueuedReportSubmission[],
): Promise<void> => {
  try {
    await AsyncStorage.setItem(
      REPORT_SUBMISSION_QUEUE_STORAGE_KEY,
      JSON.stringify(queue),
    );
  } catch (error) {
    console.error('Failed to persist report submission queue', error);
  }
};
